import React, { Component } from "react";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";

class VehicleCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      economicNumber: null,
      make: null,
      model: null,
      year: null,
      purchasedAt: null,
      color: null,
      vin: null,
      plateMx: null,
      plateUsa: null,
      scac: null,
      caat: null,
      insurancePolicy: null,
      grossWeight: null,
      supplier: null,
      type: null,
      fuel: null
    };
  }

  componentWillMount() {}

  componentDidUpdate(prevProps) {
    const props = [
      "economicNumber",
      "make",
      "model",
      "year",
      "purchasedAt",
      "color",
      "vin",
      "plateMx",
      "plateUsa",
      "scac",
      "caat",
      "insurancePolicy",
      "grossWeight",
      "supplier",
      "type",
      "fuel"
    ];
    props.forEach(prop => {
      if (this.props.values[prop] !== prevProps.values[prop]) {
        this.setState({
          [prop]: getValue(this.props.values, prop)
        });
      }
    });
  }

  render() {
    return (
      <Row gutter={10}>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"economicNumber"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "economicNumber")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"make"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "make")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"model"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "model")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"year"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "year")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"purchasedAt"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "purchasedAt")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"color"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "color")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"vin"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "vin")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"plateMx"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "plateMx")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"plateUsa"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "plateUsa")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"scac"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "scac")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"caat"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "caat")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"insurancePolicy"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "insurancePolicy")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"grossWeight"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "grossWeight")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"active"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "active")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"supplier"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "supplier")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"type"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "type")}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"fuel"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "fuel")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"vehicle"}
            attribute={"gpsSerialNumber"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "gpsSerialNumber")}
          />
        </Col>
      </Row>
    );
  }
}

export default withValues(VehicleCreate);



// WEBPACK FOOTER //
// ./src/forms/VehicleEdit.js